var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyteam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91992 18.7169V14.9969C2.91992 14.4769 3.34992 14.0469 3.86992 14.0469H8.81992",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95969 11.8881C6.80468 11.8881 7.48969 11.2031 7.48969 10.3581C7.48969 9.51313 6.80468 8.82812 5.95969 8.82812C5.11469 8.82812 4.42969 9.51313 4.42969 10.3581C4.42969 11.2031 5.11469 11.8881 5.95969 11.8881Z",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7704 18.7227V14.4127C17.7704 13.7527 17.2404 13.2227 16.5804 13.2227H11.3404C10.6804 13.2227 10.1504 13.7527 10.1504 14.4127V18.7227",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.96 11.0509C15.0204 11.0509 15.88 10.1913 15.88 9.13094C15.88 8.07055 15.0204 7.21094 13.96 7.21094C12.8997 7.21094 12.04 8.07055 12.04 9.13094C12.04 10.1913 12.8997 11.0509 13.96 11.0509Z",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0797 18.7169V14.9969C25.0797 14.4769 24.6497 14.0469 24.1297 14.0469H19.1797",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0398 11.8881C22.8848 11.8881 23.5698 11.2031 23.5698 10.3581C23.5698 9.51313 22.8848 8.82812 22.0398 8.82812C21.1948 8.82812 20.5098 9.51313 20.5098 10.3581C20.5098 11.2031 21.1948 11.8881 22.0398 11.8881Z",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21973 20.7812H25.7797",
    stroke: "#24293D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyteam);
export default __webpack_public_path__ + "static/media/myteam.d3ce0c88a4f1200ec772f74d66cc4089.svg";
export { ForwardRef as ReactComponent };